<template>
  <div class="platformList">
    <div class="management-search">
      <div class="management-search-1">
        平台名称：
        <a-input
          placeholder="请输入平台名称"
          v-model="name"
          @keyup.enter="query()"
          allow-clear
        ></a-input>
      </div>
      <div class="management-search-1">
        <a-checkbox v-model="enabled" @change="query()">是否启用</a-checkbox>
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query()">查询</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="false"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
      :customRow="customRow"
    >
      <span slot="icon" slot-scope="text" style="width: 100%">
        <a-avatar shape="square" size="large" :src="text" />
      </span>
      <span slot="enabled" slot-scope="text, record" style="width: 100%">
        <a-switch
          v-model="text"
          checkedChildren="已启用"
          unCheckedChildren="已禁用"
          @change="enabledChange($event, record)"
        />
      </span>
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click.stop="modifyClick(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            其它操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-button
                type="link"
                style="padding: 0"
                @click.stop="updateInfo(record)"
                >基本信息</a-button
              >
            </a-menu-item>
            <a-menu-item>
              <a-button
                type="link"
                style="padding: 0"
                @click.stop="preCheckCity(record)"
                >准入城市</a-button
              >
            </a-menu-item>
            <a-menu-item>
              <a-button
                type="link"
                style="padding: 0"
                @click.stop="getPlatformOptionsList(record)"
                >准入规则</a-button
              >
            </a-menu-item>
            <a-menu-item>
              <a-button
                type="link"
                style="padding: 0"
                @click.stop="getParam(record)"
                >参数</a-button
              >
            </a-menu-item>
            <a-menu-item>
              <a-button
                type="link"
                style="padding: 0"
                @click.stop="passRate(record)"
                >通过率</a-button
              >
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <a-modal
      title="编辑"
      v-model="addKeyVisible"
      :maskClosable="false"
      class="action-class"
      width="600px"
    >
      <a-form>
        <a-form-item
          label="名称:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input v-model="nameAdd" placeholder="请输入名称" />
        </a-form-item>
        <a-form-item
          label="是否独家:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-switch
            v-model="exclusive"
            checkedChildren="是"
            unCheckedChildren="否"
          />
        </a-form-item>
        <a-form-item
          label="是否成单回调:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-switch
            v-model="haveCallback"
            checkedChildren="是"
            unCheckedChildren="否"
          />
        </a-form-item>
        <a-form-item
          label="主动查询成单结果:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-switch
            v-model="needQueryResult"
            checkedChildren="是"
            unCheckedChildren="否"
          />
        </a-form-item>

        <a-form-item
          label="是否返回平台页:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-switch
            v-model="haveReturnUrl"
            checkedChildren="是"
            unCheckedChildren="否"
          />
        </a-form-item>
        <a-form-item
          label="进件时间:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-time-picker v-model="apiTimeStart" placeholder="开始时间">
          </a-time-picker>
          <i style="display: inline-block; margin-left: 20px"></i>
          <a-time-picker v-model="apiTimeEnd" placeholder="结束时间">
          </a-time-picker>
        </a-form-item>
        <a-form-item
          label="备注:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea :rows="5" v-model="remark" placeholder="请输入备注" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="modify_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      title="基本信息"
      v-model="infoVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="简称:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.name"
            placeholder="请输入简称"
          />
        </a-form-item>
        <a-form-item
          label="副标题:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.remark"
            placeholder="副标题"
          />
        </a-form-item>
        <a-form-item
          label="全称:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.fullName"
            placeholder="请输入全称"
          />
        </a-form-item>
        <a-form-item
          label="额度:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.amount"
            placeholder="请输入额度"
          />
        </a-form-item>
        <a-form-item
          label="期数:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.time"
            placeholder="请输入期数"
          />
        </a-form-item>
        <a-form-item
          label="利率:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-model="qualificationPlatformInfo.rate"
            placeholder="请输入利率"
          />
        </a-form-item>
        <a-form-item
          label="图标:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-model="qualificationPlatformInfo.icon"
            placeholder="请选择图标"
            class="select-tag"
            allowClear
            style="height: 80px; line-height: 80px"
          >
            <a-select-option
              v-for="(item, index) in iconList"
              :key="index"
              :value="item.imageUrl"
            >
              <a-avatar shape="square" :size="64" :src="item.imageUrl" />
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="infoVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="info_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      title="准入条件"
      v-model="preCheckCityVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="包含:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="optionalList"
            :options="options"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
          <a-tooltip placement="topLeft" style="margin-left: 5px">
            <template slot="title">{{ getCity(optionalList) }}</template>
            <a-icon type="question-circle" />
          </a-tooltip>
          <a-button type="link" @click="quickTypingIn('包含')"
            >快速输入</a-button
          >
        </a-form-item>
        <a-form-item
          label="排除:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="preclusiveList"
            :options="options"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
          <a-tooltip placement="topLeft" style="margin-left: 5px">
            <template slot="title">{{ getCity(preclusiveList) }}</template>
            <a-icon type="question-circle" />
          </a-tooltip>
          <a-button type="link" @click="quickTypingIn('排除')"
            >快速输入</a-button
          >
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="preCheckCityVisible = false"
            >取消</a-button
          >
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="preCheckCity_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      :title="title"
      v-model="visible"
      :maskClosable="false"
      :after-close="close"
      class="action-class"
      width="600px"
    >
      <a-form>
        <a-form-item
          label="区域:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea :rows="10" v-model="area" placeholder="请输入区域" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="visible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="quickTypingInSubmit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      title="参数"
      v-model="paramVisible"
      :maskClosable="false"
      class="action-class"
      width="800px"
    >
      <div style="margin-bottom: 20px">
        <a-button type="primary" @click="addParam">新增</a-button>
      </div>
      <a-table
        :columns="paramTableColumns"
        :dataSource="paramTableDataSource"
        :pagination="false"
        size="middle"
        :rowKey="(record) => record.id"
      >
        <span slot="defaultParam" slot-scope="text, record" style="width: 100%">
          <a-switch
            v-model="text"
            checkedChildren="是"
            unCheckedChildren="否"
            @change="defaultParamChange($event, record)"
            :disabled="text"
          />
        </span>
        <span slot="enabled" slot-scope="text, record" style="width: 100%">
          <a-switch
            v-model="text"
            checkedChildren="已启用"
            unCheckedChildren="已禁用"
            @change="paramEnabledChange($event, record)"
          />
        </span>
        <span slot="action" slot-scope="text, record">
          <a href="javascript:;" @click.stop="editParam(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            placement="right"
            okText="确认"
            cancelText="取消"
            @confirm="deleteParam(record)"
          >
            <template slot="title">是否确认删除{{ record.name }}</template>
            <a href="javascript:;" style="color: #ff4d4f">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="paramVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      :title="paramTitle"
      v-model="editParamVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="参数"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea :rows="5" v-model="param" placeholder="请输入参数" />
        </a-form-item>
        <a-form-item
          label="是否启用:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          v-if="this.paramTitle == '新增参数'"
        >
          <a-switch
            v-model="enabledParam"
            checkedChildren="是"
            unCheckedChildren="否"
          />
        </a-form-item>
        <a-form-item
          label="备注:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          v-if="this.paramTitle == '新增参数'"
        >
          <a-textarea
            :rows="5"
            v-model="remarkParam"
            placeholder="请输入备注"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="editParamVisible = false">取消</a-button>
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="param_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>

    <a-modal
      title="通过率"
      v-model="rateVisible"
      :maskClosable="false"
      class="action-class"
      width="800px"
    >
      <div id="myChart" style="height: 500px; width: 100%"></div>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="rateVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      title="准入规则列表"
      v-model="preCheckVisible"
      :maskClosable="false"
      class="action-class"
      width="1200px"
    >
      <div style="margin-bottom: 20px">
        <a-button type="primary" @click="addPreCheck()">新增</a-button>
      </div>
      <a-table
        :columns="preCheckColumns"
        :dataSource="preCheckList"
        :pagination="false"
        :rowKey="(record) => record.id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a-button type="link" style="padding: 0" @click="editPreCheck(record)"
            >修改</a-button
          >
          <a-divider type="vertical" />
          <a-popconfirm
            placement="right"
            okText="确认"
            cancelText="取消"
            @confirm="deletePreCheck(record)"
          >
            <template slot="title">是否确认删除</template>
            <a href="javascript:;" style="color: #ff4d4f">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="preCheckVisible = false">关闭</a-button>
        </div>
      </template>
    </a-modal>

    <a-modal
      :title="preCheckTitle"
      v-model="preCheckEditVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="城市:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="cityList"
            :options="options"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
        </a-form-item>
        <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <span slot="label">
            年龄
            <a-tooltip placement="topLeft">
              <template slot="title"> -1代表不限制 </template>
              <a-icon type="info-circle" />
            </a-tooltip>
          </span>
          <a-input v-model="minAge" placeholder="最小年龄" style="width: 20%" />
          ——
          <a-input v-model="maxAge" placeholder="最大年龄" style="width: 20%" />
        </a-form-item>

        <a-form-item
          label="进件时间:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-time-picker v-model="apiTimeStart" placeholder="开始时间">
          </a-time-picker>
          <i style="display: inline-block; margin-left: 20px"></i>
          <a-time-picker v-model="apiTimeEnd" placeholder="结束时间">
          </a-time-picker>
        </a-form-item>
        <a-form-item
          label="包含资质:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="optionalList"
            :options="platformOptionsList"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
        </a-form-item>
        <a-form-item
          label="排除资质:"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <el-cascader
            v-model="preclusiveList"
            :options="platformOptionsList"
            :props="props"
            filterable
            :show-all-levels="false"
            clearable
            collapse-tags
            size="small"
          ></el-cascader>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="preCheckEditVisible = false"
            >取消</a-button
          >
          <a-button
            key="submit"
            type="primary"
            :loading="loading"
            @click="editPreCheck_submit()"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/platformList.js";
import formMaintenanceApi from "../lib/formMaintenance.js";
import moment from "moment";
import * as echarts from "echarts";

export default {
  name: "platformList",
  data() {
    return {
      title: "",
      nameAdd: undefined,
      id: "",
      addKeyVisible: false,
      loading: false,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "平台名称",
          dataIndex: "name",
        },
        {
          title: "编码",
          dataIndex: "code",
        },
        {
          title: "图标",
          dataIndex: "icon",
          scopedSlots: { customRender: "icon" },
        },
        {
          title: "状态",
          dataIndex: "enabled",
          scopedSlots: { customRender: "enabled" },
        },
        {
          title: "进件时间",
          dataIndex: "apiTimeStart",
          customRender: (text, row, index) => {
            if (text && row.apiTimeEnd) {
              return {
                children: (
                  <span>
                    {text}—{row.apiTimeEnd}
                  </span>
                ),
              };
            }
            return <span></span>;
          },
        },
        {
          title: "备注",
          dataIndex: "remark",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      area: "",
      props: {
        multiple: true,
        children: "childrenList",
        value: "id",
        label: "content",
        emitPath: false,
      },
      options: [],
      name: "",
      sourceObj: null,
      targetObj: null,
      sourceIndex: null,
      targetIndex: null,
      enabledAdd: false,
      remark: "",
      haveCallback: false,
      needQueryResult: false,
      haveReturnUrl: false,
      exclusive: false,
      infoVisible: false,
      qualificationPlatformInfo: {
        name: "",
        fullName: "",
        icon: undefined,
        amount: "",
        time: "",
        rate: "",
        remark: "",
      },
      preCheckCityVisible: false,
      iconList: [],
      optionalList: [],
      preclusiveList: [],
      visible: false,
      paramVisible: false,
      editParamVisible: false,
      paramTableDataSource: [],
      paramTableColumns: [
        {
          title: "编号",
          dataIndex: "id",
        },
        {
          title: "是否默认参数",
          dataIndex: "defaultParam",
          scopedSlots: { customRender: "defaultParam" },
        },
        {
          title: "状态",
          dataIndex: "enabled",
          scopedSlots: { customRender: "enabled" },
        },
        {
          title: "备注",
          dataIndex: "remark",
        },
        {
          title: "创建时间",
          dataIndex: "gmtCreated",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      platformId: "",
      paramTitle: "",
      param: "",
      paramId: "",
      enabledParam: true,
      remarkParam: "",
      apiTimeStart: null,
      apiTimeEnd: null,
      enabled: true,
      rateVisible: false,
      preCheckList: [],
      preCheckColumns: [
        {
          title: "编号",
          dataIndex: "id",
          width: 60,
        },
        {
          title: () => {
            return (
              <span>
                城市
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    未匹配上则跳过，为空则符合所有城市
                  </template>
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "cityListLabel",
          width: 250,
          ellipsis: true,
        },
        {
          title: "年龄",
          dataIndex: "age",
          scopedSlots: { customRender: "age" },
          width: 85,
        },
        {
          title: "包含资质",
          dataIndex: "optionalListLabel",
          width: 250,
          ellipsis: true,
        },
        {
          title: "排除资质",
          dataIndex: "preclusiveListLabel",
          width: 250,
          ellipsis: true,
        },
        {
          title: "进件时间",
          dataIndex: "apiTime",
          width: 170,
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      preCheckVisible: false,
      preCheckTitle: "",
      preCheckEditVisible: false,
      platformOptionsList: [],
      cityList: [],
      minAge: "",
      maxAge: "",
      preCheckId: "",
    };
  },
  computed: {
    formatEndTime() {
      // 开始时间
      if (this.apiTimeEnd) {
        return this.$common.transformTime(this.apiTimeEnd).split(" ")[1];
      }
      return "";
    },
    formatStartTime() {
      // 结束时间
      if (this.apiTimeStart) {
        return this.$common.transformTime(this.apiTimeStart).split(" ")[1];
      }
      return "";
    },
    getCity() {
      return (arr) => {
        let areaArr = [];
        this.options.forEach((province) => {
          province.childrenList.forEach((city) => {
            arr.forEach((item) => {
              if (city.id == item) {
                areaArr.push(city.content);
              }
            });
          });
        });
        return areaArr.join(",");
      };
    },
  },
  mounted() {
    this.query();
    this.getAreaList();
    this.getIconList();
  },
  methods: {
    moment,
    editPreCheck_submit() {
      let data = {
        minAge: this.minAge,
        maxAge: this.maxAge,
        cityList: this.cityList,
        optionalList: this.optionalList,
        preclusiveList: this.preclusiveList,
        apiTimeStart: this.formatStartTime,
        apiTimeEnd: this.formatEndTime,
      };
      if (this.preCheckTitle == "新增准入规则") {
        data.platformId = this.id;
        api.addPreCheck(data).then((res) => {
          if (res.result == 200) {
            this.$message.success("新增成功");
            this.preCheckEditVisible = false;
            this.preCheck();
          }
        });
      } else {
        data.id = this.preCheckId;
        api.updatePreCheck(data).then((res) => {
          if (res.result == 200) {
            this.$message.success("修改成功");
            this.preCheckEditVisible = false;
            this.preCheck();
          }
        });
      }
    },
    addPreCheck() {
      this.preCheckTitle = "新增准入规则";
      this.minAge = "";
      this.maxAge = "";
      this.cityList = [];
      this.optionalList = [];
      this.preclusiveList = [];
      this.apiTimeStart = null;
      this.apiTimeEnd = null;
      this.preCheckEditVisible = true;
    },
    editPreCheck(val) {
      this.preCheckId = val.id;
      this.preCheckTitle = "修改准入规则";
      this.minAge = val.minAge;
      this.maxAge = val.maxAge;
      if (val.cityList) {
        this.cityList = val.cityList;
      } else {
        this.cityList = [];
      }
      if (val.optionalList) {
        this.optionalList = val.optionalList;
      } else {
        this.optionalList = [];
      }
      if (val.preclusiveList) {
        this.preclusiveList = val.preclusiveList;
      } else {
        this.preclusiveList = [];
      }
      if (val.apiTimeStart) {
        this.apiTimeStart = moment(val.apiTimeStart, "HH:mm:ss");
      } else {
        this.apiTimeStart = null;
      }
      if (val.apiTimeEnd) {
        this.apiTimeEnd = moment(val.apiTimeEnd, "HH:mm:ss");
      } else {
        this.apiTimeEnd = null;
      }
      this.preCheckEditVisible = true;
    },
    deletePreCheck(val) {
      api.deletePreCheck({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.preCheck();
        }
      });
    },
    preCheck() {
      api.getPreCheckList({ platformId: this.id }).then((res) => {
        if (res.result == 200) {
          this.preCheckList.splice(0);
          if (res.data) {
            this.preCheckList.push(...res.data);
            this.preCheckList.forEach((item) => {
              this.$set(
                item,
                "age",
                item.minAge + " - " + (item.maxAge ? item.maxAge : "")
              );
              if (item.apiTimeStart && item.apiTimeEnd) {
                this.$set(
                  item,
                  "apiTime",
                  item.apiTimeStart + " - " + item.apiTimeEnd
                );
              } else {
                this.$set(item, "apiTime", "");
              }
              let cityListLabel = [];
              let optionalListLabel = [];
              let preclusiveListLabel = [];
              if (item.cityList) {
                this.options.forEach((province) => {
                  province.childrenList.forEach((city) => {
                    item.cityList.forEach((cityId) => {
                      if (city.id == cityId) {
                        cityListLabel.push(city.content);
                      }
                    });
                  });
                });
              }
              if (item.optionalList) {
                this.platformOptionsList.forEach((platformOption) => {
                  platformOption.childrenList.forEach((option) => {
                    item.optionalList.forEach((optionId) => {
                      if (option.id == optionId) {
                        optionalListLabel.push(option.content);
                      }
                    });
                  });
                });
              }
              if (item.preclusiveList) {
                this.platformOptionsList.forEach((platformOption) => {
                  platformOption.childrenList.forEach((option) => {
                    item.preclusiveList.forEach((optionId) => {
                      if (option.id == optionId) {
                        preclusiveListLabel.push(option.content);
                      }
                    });
                  });
                });
              }
              this.$set(item, "cityListLabel", cityListLabel.join(","));
              this.$set(item, "optionalListLabel", optionalListLabel.join(","));
              this.$set(
                item,
                "preclusiveListLabel",
                preclusiveListLabel.join(",")
              );
            });
          }
          this.preCheckVisible = true;
        }
      });
    },
    getPlatformOptionsList(val) {
      if (val) {
        this.id = val.id;
      }
      formMaintenanceApi
        .listPlatformQualification({
          platformId: this.id,
          enabled: true,
        })
        .then((res) => {
          if (res.result == 200) {
            this.platformOptionsList.splice(0);
            res.data.forEach((item) => {
              if (!item.isCity && item.type == "OPTION") {
                item.childrenList = item.qualificationOptionList;
                item.content = item.name;
                this.platformOptionsList.push(item);
              }
            });
            this.preCheck();
          }
        });
    },
    disabledStartTime(startValue) {
      const endValue = this.apiTimeEnd;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndTime(endValue) {
      const startValue = this.apiTimeStart;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    param_submit() {
      if (this.paramTitle == "新增参数") {
        api
          .addParam({
            platformId: this.platformId,
            param: this.param,
            enabled: this.enabledParam,
            remark: this.remarkParam,
          })
          .then((res) => {
            if (res.result == 200) {
              this.$message.success("添加成功");
              this.paramList();
              this.editParamVisible = false;
            }
          });
      } else {
        api.updateParam({ id: this.paramId, param: this.param }).then((res) => {
          if (res.result == 200) {
            this.$message.success("修改成功");
            this.paramList();
            this.editParamVisible = false;
          }
        });
      }
    },
    addParam() {
      this.paramTitle = "新增参数";
      this.enabledParam = true;
      this.remarkParam = "";
      this.param = "";
      this.editParamVisible = true;
    },
    editParam(val) {
      this.paramTitle = "修改参数";
      this.param = val.param;
      this.paramId = val.id;
      this.editParamVisible = true;
    },
    deleteParam(val) {
      api.deleteParam({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.paramList();
        }
      });
    },
    paramEnabledChange(enabled, val) {
      api.enableParam({ id: val.id, enabled }).then((res) => {
        if (res.result == 200) {
          if (enabled) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("禁用成功");
          }
          this.paramList();
        }
      });
    },
    defaultParamChange(enabled, val) {
      api.changeDefaultParam({ id: val.id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("修改默认参数成功");
          this.paramList();
        }
      });
    },
    enabledChange(enabled, val) {
      api.enable({ id: val.id, enabled }).then((res) => {
        if (res.result == 200) {
          if (enabled) {
            this.$message.success("启用成功");
          } else {
            this.$message.success("禁用成功");
          }
          this.query();
        }
      });
    },
    close() {
      this.preCheckCityVisible = true;
    },
    removeTrim(array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i] == "") {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    quickTypingInSubmit() {
      this.visible = false;
      this.$nextTick(() => {
        this.area = this.area.replace(/，/g, ",");
        this.area = this.area.replace(/ /g, ",");
        this.area = this.area.replace(/\|/g, ",");
        this.area = this.area.replace(/\｜/g, ",");
        let areaArr = this.area.split(",");
        areaArr = this.removeTrim(areaArr);
        let preclusiveList = [],
          optionalList = [];
        areaArr.map((areaItem, index) => {
          this.options.map((item) => {
            item.childrenList.map((childrenItem) => {
              if (areaItem == childrenItem.content) {
                if (this.title == "包含") {
                  optionalList.push(childrenItem.id);
                } else {
                  preclusiveList.push(childrenItem.id);
                }
              }
            });
          });
        });
        if (this.title == "包含") {
          this.optionalList = optionalList;
        } else {
          this.preclusiveList = preclusiveList;
        }
      });
    },
    quickTypingIn(type) {
      this.title = type;
      let areaArr;
      if (type == "包含") {
        areaArr = this.getCity(this.optionalList);
      } else {
        areaArr = this.getCity(this.preclusiveList);
      }
      this.area = areaArr;
      this.visible = true;
      this.preCheckCityVisible = false;
    },
    getIconList() {
      api.queryImageList().then((res) => {
        if (res.result == 200) {
          this.iconList = res.data;
        }
      });
    },
    info_submit() {
      api
        .updateInfo({
          id: this.id,
          qualificationPlatformInfo: this.qualificationPlatformInfo,
        })
        .then((res) => {
          if (res.result == 200) {
            this.infoVisible = false;
            this.$message.success("修改成功");
            this.query();
          }
        });
    },
    updateInfo(val) {
      this.id = val.id;
      if (val.infoVo) {
        this.qualificationPlatformInfo = val.infoVo;
      } else {
        this.qualificationPlatformInfo = {
          name: "",
          fullName: "",
          icon: undefined,
          amount: "",
          time: "",
          rate: "",
          remark: "",
        };
      }
      this.infoVisible = true;
    },
    passRate(val) {
      api.passRate({ platformId: val.id }).then((res) => {
        if (res.result == 200) {
          this.rateVisible = true;
          this.$nextTick(() => {
            let myChart = echarts.init(document.getElementById("myChart"));
            // 绘制图表
            myChart.setOption({
              title: {
                text: val.name + "通过率",
              },
              tooltip: {
                trigger: "axis",
              },
              color: ["#91cc75"],
              xAxis: {
                data: res.data.dateList,
              },
              yAxis: {
                type: "value",
              },
              series: [
                {
                  name: "通过率",
                  type: "line",
                  data: res.data.rateList,
                },
              ],
            });
          });
        }
      });
    },
    getParam(val) {
      this.platformId = val.id;
      this.paramList();
    },
    paramList() {
      api.paramList({ platformId: this.platformId }).then((res) => {
        if (res.result == 200) {
          this.paramTableDataSource.splice(0);
          this.paramTableDataSource.push(...res.data);
          this.paramVisible = true;
        }
      });
    },
    preCheckCity(val) {
      this.id = val.id;
      api.getPreCheckCity({ platformId: val.id }).then((res) => {
        if (res.result == 200) {
          this.preclusiveList = res.data.preclusive;
          this.optionalList = res.data.optional;
          this.preCheckCityVisible = true;
        }
      });
    },
    preCheckCity_submit() {
      let data = {
        platformId: this.id,
        preclusiveList: this.preclusiveList,
        optionalList: this.optionalList,
      };

      api.updatePreCheckCity(data).then((res) => {
        if (res.result == 200) {
          this.preCheckCityVisible = false;
          this.$message.success("修改成功");
          this.query();
        }
      });
    },
    customRow(record, index) {
      return {
        style: {
          cursor: "pointer",
        },
        on: {
          // 鼠标移入
          mouseenter: (event) => {
            // 兼容IE
            var ev = event || window.event;
            ev.target.draggable = true;
          },
          // 开始拖拽
          dragstart: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到源目标数据
            this.sourceObj = record;
            this.sourceIndex = index;
          },
          // 拖动元素经过的元素
          dragover: (event) => {
            // 兼容 IE
            var ev = event || window.event;
            // 阻止默认行为
            ev.preventDefault();
          },
          // 鼠标松开
          drop: (event) => {
            // 兼容IE
            var ev = event || window.event;
            // 阻止冒泡
            ev.stopPropagation();
            // 得到目标数据
            this.targetObj = record;
            this.targetIndex = index;
            if (this.sourceObj.id !== this.targetObj.id) {
              this.tableDataSource.splice(this.sourceIndex, 1);
              this.tableDataSource.splice(this.targetIndex, 0, this.sourceObj);
              this.sort();
            }
            this.targetObj = null;
            this.sourceObj = null;
            this.sourceIndex = null;
            this.targetIndex = null;
          },
        },
      };
    },
    sort() {
      let platformList = [];
      this.tableDataSource.forEach((item, index) => {
        platformList.push({ id: item.id, order: index + 1 });
      });
      api.updateIndex({ platformList }).then((res) => {
        if (res.result == 200) {
          this.$message.success("修改排序成功");
          this.query();
        }
      });
    },
    getAreaList() {
      api.areaList().then((res) => {
        if (res.result == 200) {
          this.options = res.data;
        }
      });
    },
    // 点击查询
    query() {
      let data = {
        name: this.name,
        enabled: this.enabled,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data;
            this.tableDataSource = list;
            this.tableDataSource.forEach((item) => {
              if (item.infoVo) {
                this.$set(item, "icon", item.infoVo.icon);
              } else {
                this.$set(item, "icon", "");
              }
            });
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    // 修改
    modifyClick(val) {
      this.addKeyVisible = true;
      this.id = val.id;
      this.nameAdd = val.name;
      this.haveCallback = val.haveCallback;
      this.needQueryResult = val.needQueryResult;
      if (val.apiTimeStart) {
        this.apiTimeStart = moment(val.apiTimeStart, "HH:mm:ss");
      } else {
        this.apiTimeStart = null;
      }
      if (val.apiTimeEnd) {
        this.apiTimeEnd = moment(val.apiTimeEnd, "HH:mm:ss");
      } else {
        this.apiTimeEnd = null;
      }
      this.haveReturnUrl = val.haveReturnUrl;
      this.exclusive = val.exclusive;
      this.remark = val.remark;
    },
    modify_submit() {
      let data = {
        id: this.id,
        name: this.nameAdd,
        haveCallback: this.haveCallback,
        needQueryResult: this.needQueryResult,
        haveReturnUrl: this.haveReturnUrl,
        exclusive: this.exclusive,
        remark: this.remark,
        apiTimeStart: this.formatStartTime,
        apiTimeEnd: this.formatEndTime,
      };
      api.update(data).then((res) => {
        if (res.result == 200) {
          this.$message.success("编辑成功");
          this.addKeyVisible = false;
          this.query();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-cascader {
  margin-bottom: 0px !important;
  &:deep() .el-cascader__search-input {
    min-width: 2px;
  }
}

:deep() .ant-select-selection--single {
  height: 80px !important;
  line-height: 80px !important;
  .ant-select-selection__rendered {
    height: 80px !important;
    line-height: 80px !important;
  }
}
.platformList {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
